import React, { FC } from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { DarkSkeleton } from '@eika/skeleton';

import { LoanAccount } from '../../../generated-types';
import { useTranslation } from '../../../translations';

import '../LoanOverview.scss';

interface Props {
    isLoading: boolean;
    loanAccount?: LoanAccount;
    newAccount?: boolean;
    loanPayedDown?: boolean;
}

const LoanAccountHeader: FC<Props> = ({ isLoading, loanAccount, newAccount = false, loanPayedDown = false }) => {
    const translated = useTranslation();

    if (isLoading) {
        return (
            <div className="loan-account-header__wrapper">
                <dl className="sgw-account-details__meta skeleton">
                    <dd className="loan-account__name">
                        <h1 className="light">
                            <DarkSkeleton width={200} />
                        </h1>
                    </dd>
                </dl>
                {newAccount && <DarkSkeleton width={300} height={75} />}
                {loanPayedDown && <DarkSkeleton width={300} height={55} />}
            </div>
        );
    }

    if (!loanAccount) return <></>;

    return (
        <div className="loan-account-header__wrapper">
            <dl className="sgw-account-details__meta" itemScope itemType="https://schema.org/DepositAccount">
                <dt className="screen-reader-text">{translated.loanOverview.accountName}</dt>
                <dd itemProp="name" className="loan-account__name">
                    <h1 className="light">{loanAccount.productName}</h1>
                </dd>
            </dl>
            {newAccount && (
                <AttentionMessage
                    className="loan-account__label"
                    text={translated.loanOverview.moneyOnTheWay}
                    icon={IconTypes.UTROPSTEGN_24}
                    type="pending"
                />
            )}
            {loanPayedDown && (
                <AttentionMessage
                    className="loan-account__label"
                    text={translated.loanOverview.loanPayedDown}
                    icon={IconTypes.USP_CHECKMARK_24}
                    type="success"
                />
            )}
        </div>
    );
};

export default LoanAccountHeader;
